<script setup>
  import SidebarLayout from './components/SidebarLayout.vue'
</script>

<template>
  <div id="app">
    <SidebarLayout />
    <DynamicDialog />
  </div>
</template>

<style>
  #app {
    font-family: 'Quicksand', Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    position: relative;
  }

  .app-container {
    position: relative;
    z-index: 1;
  }

  html,
  body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    overflow-y: auto;
    height: auto;
    min-height: 100vh;
  }

  /* Custom scrollbar styling */
  * {
    /* Firefox */
    scrollbar-width: thin;
    scrollbar-color: rgba(200, 200, 200, 0.7) transparent;
  }

  /* Webkit browsers (Chrome, Safari, Edge) */
  *::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  *::-webkit-scrollbar-track {
    background: transparent;
  }

  *::-webkit-scrollbar-thumb {
    background-color: rgba(200, 200, 200, 0.7);
    border-radius: 4px;
    border: 1px solid transparent;
    background-clip: content-box;
  }

  *::-webkit-scrollbar-thumb:hover {
    background-color: rgba(180, 180, 180, 0.8);
  }

  *::-webkit-scrollbar-corner {
    background: transparent;
  }
</style>
